export const FAMILY_DEFAULT_MEMBERS_NUMBER = 6;
